import { CaseRunCalculateDetailModel, CaseRunDetailReadModel } from "@app/api2/api";
import React from "react";
import { PageBreak } from "@common/PageBreak";
import { CalculationDetails } from "../Details/CalculationDetails";
import { CalculationResults } from "../Details/CalculationResults";

interface ICalculationsProps {
    // model: MaxLrCaseRunDetailReadModel | MaxLrAicCaseRunDetailReadModel;
    model: CaseRunDetailReadModel;
    calculations: CaseRunCalculateDetailModel[];
}

export const Calculations: React.FunctionComponent<ICalculationsProps> = (props) => {
    const t = window.translation;
    // const hp = props.model.results.hypotheses.find(x => x.type == 'p')
    // const hd = props.model.results.hypotheses.find(x => x.type == 'd')
    return <>
        {props.calculations?.map(calculation => (
            <div key={`calc_${calculation.id}_${calculation.type}`}>
                <PageBreak />
                <h3 >{window.translation.runType[calculation.type]} Details</h3>
                <table className="two-col-layout">
                    <tbody>
                        <tr>
                            <td>
                                <CalculationDetails model={calculation} forPrint />
                            </td>
                            <td>
                                <CalculationResults model={calculation} forPrint />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        ))
        }
    </>
};
